import React, { useRef } from "react";
import { LeftOutlined, RightOutlined, StarOutlined } from "@ant-design/icons";
import "./HeaderCarousel.scss"
import { Row, Col } from "antd";
import DishAndDetails from "./DishAndDetails";
import FilterBar from "./FilterBar";


const foodItems = [
    { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
    { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
    { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
    { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
    { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
    { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
    { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
    { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
    { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
    { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
    { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
    { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
    { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
    { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
  ];
interface Featured {
    title?: String
};

const ResaturantDeliverings = ({title}:Featured) => {
  

  return (
    <div style={{ position: "relative", padding: "20px 0px" }}>
    
    <div className="header-text">{"Resaturant Deliverings"}</div>

    <FilterBar/>

     

    <Row gutter={[20, 20]} style={{ paddingTop: 40 }}>
  {foodItems.map((item, index) => (
    <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
      <DishAndDetails dish={item} index={index} />
    </Col>
  ))}
</Row>
    </div>
  );
};

export default ResaturantDeliverings;
